import {
  apiCollection,
  apiResource,
  apiFormSubmit,
  apiDelete,
  apiPut,
} from './index';
export default {
  // 获取直播列表数据
  getLiveList: opts => {
    return apiCollection ({url: '/v1/app/live', params: {...opts}});
  },
  // 获取直播详情
  getLiveDetail: opts => {
    return apiCollection ({url: `/v1/app/live/${opts.uuid}`, data: opts});
  },
  // 获取直播分类
  getLiveType: opts => {
    return apiCollection ({url: '/v1/app/LiveCate', params: {...opts}});
  },
  // 观看直播
  playLiveing: opts => {
    return apiCollection ({url: `/v1/app/LivePush/${opts.uuid}`, data: opts});
  },
  // 发送弹幕
  sendBarrage: opts => {
    return apiResource ({url: '/v1/app/Barrage', data: opts});
  },
  // 获取弹幕列表
  getBarrageList: opts => {
    return apiCollection ({url: '/v1/app/Barrage', params: {...opts}});
  },
  // 发送验证码
  sendCode: opts => {
    return apiResource ({url: '/v1/common/Captcha', data: opts});
  },
  // 登录
  login: opts => {
    return apiResource ({url: '/v1/app/MobileLogin', data: opts});
  },
  // 获取是否绑定过密码
  getPwdStatus: opts => {
    return apiCollection ({url: '/v1/app/mobilelogin/pwd_status', params: opts});
  },
  // 密码登录
  pwdLogin: opts => {
    return apiResource ({url: '/v1/app/mobilelogin/pwd_login', data: opts});
  },
  // 直播计时
  liveSendTime: opts => {
    return apiResource ({url: '/v1/app/LiveOption', data: opts});
  },
  // 文章列表
  getArticleList: opts => {
    return apiCollection ({url: '/v1/app/Article', params: {...opts}});
  },
  // 文章分类
  getArticleType: opts => {
    return apiCollection ({url: '/v1/app/ArticleCate', params: {...opts}});
  },
  // 文章详情
  getArticleDetail: opts => {
    return apiCollection ({
      url: `/v1/app/Article/${opts.uuid}`,
      data: opts,
    });
  },
  // 课程列表
  getCourseList: opts => {
    return apiCollection ({url: '/v1/app/course', params: {...opts}});
  },
  // 课程详情
  getCourseDetail: opts => {
    return apiCollection ({
      url: `/v1/app/course/${opts.uuid}`,
      data: opts,
    });
  },
  getMyCourseDetail: opts => {
    return apiCollection ({
      url: `/v1/app/CourseView/${opts.section_uuid}`,
      data: opts,
    });
  },
  //   加入我们
  joinUs: opts => {
    return apiResource ({url: '/v1/app/JoinUs', data: opts});
  },
  // 试卷列表
  getExamList: opts => {
    return apiCollection ({url: '/v1/app/paper', params: {...opts}});
  },
  // 试题列表
  getSubjectList: opts => {
    return apiCollection ({url: '/v1/app/subject', params: {...opts}});
  },
  // 线上考试
  onlineExam: opts => {
    return apiResource ({url: '/v1/app/ReceiverSubject', data: opts});
  },
  // 考试结果
  getExamResult: opts => {
    return apiCollection ({url: '/v1/app/ReceiverSubject', params: {...opts}});
  },
  // 考试总计
  getTotalScore: opts => {
    return apiCollection ({url: `/v1/app/TotalScore/${opts.uuid}`, data: opts});
  },
  //   书斋列表
  getRoomList: opts => {
    return apiCollection ({url: '/v1/app/good', params: {...opts}});
  },
  // 商品详情
  getShopDetail: opts => {
    return apiCollection ({
      url: `/v1/app/good/${opts.uuid}`,
      data: opts,
    });
  },
  //   荣誉殿堂
  getHornorList: opts => {
    return apiCollection ({url: '/v1/app/certificate', params: {...opts}});
  },
  // 获取图片地址
  getImgUrl: opts => {
    return apiResource ({url: '/v1/common/UploadUrlImg', data: opts});
  },
  //   保存信息
  saveMyinfo: opts => {
    return apiResource ({url: '/v1/app/Userinfo', data: opts});
  },
  // 商品评论列表
  getShopComment: opts => {
    return apiCollection ({url: '/v1/app/GoodEvaluate', params: {...opts}});
  },
  // 商品评论
  evaluateGood: opts => {
    return apiResource ({url: '/v1/app/GoodEvaluate', data: opts});
  },
  // 课程评论列表
  getCourseComment: opts => {
    return apiCollection ({url: '/v1/app/CourseEvaluate', params: {...opts}});
  },
  // 课程评价
  evaluateCourse: opts => {
    return apiResource ({url: '/v1/app/CourseEvaluate', data: opts});
  },
  // 获取个人详情
  getMyinfo: opts => {
    return apiCollection ({url: '/v1/app/UserInfo', params: {...opts}});
  },
  // 加入购物车
  addCart: opts => {
    return apiResource ({url: '/v1/app/GoodCar', data: opts});
  },
  // 线下考试报名
  offlineSign: opts => {
    return apiResource ({url: '/v1/app/ExamReport', data: opts});
  },
  // 获取学校列表
  getSchoolList: opts => {
    return apiCollection ({url: '/v1/app/school', params: {...opts}});
  },
  // 个人档案信息获取
  getMyInformation: opts => {
    return apiCollection ({url: '/v1/app/Archive', params: {...opts}});
  },
  // 保存个人档案信息
  saveMyInformation: opts => {
    return apiResource ({url: '/v1/app/Archive', data: opts});
  },
  // 检测可购买的课程等级
  courseCheck: opts => {
    return apiResource ({url: '/v1/app/courseCheck', data: opts});
  },
  // 创建课程订单
  courseOrder: opts => {
    return apiResource ({url: '/v1/app/CourseOrder', data: opts});
  },
  // 上传支付凭证
  uploadPlayImg: opts => {
    return apiPut ({
      url: `/v1/app/CourseOrder/${opts.order_sn}`,
      data: opts,
    });
  },
  // 获取个人中心我的课程/v1/app/userOrder
  getMyCourseList: opts => {
    return apiCollection ({url: '/v1/app/userOrder', params: {...opts}});
  },
  // 获取课程表
  getTimetable: opts => {
    return apiCollection ({
      url: `/v1/app/userOrder/${opts.order_id}`,
      data: opts,
    });
  },
  // 创建书斋订单
  getGoodOrder: opts => {
    return apiResource ({url: '/v1/app/GoodOrder', data: opts});
  },
  // 获取订单列表
  getOrderList: opts => {
    return apiCollection ({url: '/v1/app/GoodOrder', params: {...opts}});
  },
  // 下单
  submitOrder: opts => {
    return apiPut ({
      url: `/v1/app/GoodOrder/${opts.order_sn}`,
      data: opts,
    });
  },
  // 获取地址
  getAddressList: opts => {
    return apiCollection ({url: '/v1/app/Address', params: {...opts}});
  },
  // 添加地址
  addAdress: opts => {
    return apiResource ({url: '/v1/app/Address', data: opts});
  },
  // 编辑地址
  editAddress: opts => {
    return apiPut ({
      url: `/v1/app/Address/${opts.address_id}`,
      data: opts,
    });
  },
  // 删除地址
  deleteAddress: opts => {
    return apiDelete ({
      url: `/v1/app/Address/${opts.address_id}`,
      data: opts,
    });
  },
  // 获取省市区街道
  getProvince: opts => {
    return apiCollection ({url: '/v1/common/Area', params: {...opts}});
  },
  // 商品支付
  commodityPay: opts => {
    return apiResource ({
      url: `/v1/app/Pay`,
      data: opts,
    });
  },
  // 获取购物车列表
  getShopList: opts => {
    return apiCollection ({url: '/v1/app/GoodCar', params: {...opts}});
  },
  // 删除购物车商品
  deleteShop: opts => {
    return apiDelete ({
      url: `/v1/app/GoodCar/${opts.id}`,
      data: opts,
    });
  },
  // 批量删除购物车商品
  deleteAllShop: opts => {
    return apiResource ({url: '/v1/app/GoodCarBatch', data: opts});
  },
  // 取消订单
  cancelOrder: opts => {
    return apiResource ({
      url: `/v1/app/GoodOrderCancel`,
      data: opts,
    });
  },
  // 确认收货
  confirmRecevie: opts => {
    return apiResource ({
      url: `/v1/app/GoodOrderShip`,
      data: opts,
    });
  },
  // 申请开票
  applyBill: opts => {
    return apiResource ({
      url: `/v1/app/GoodOrderTicket`,
      data: opts,
    });
  },
  // 获取订单详情
  getOrderDetail: opts => {
    return apiCollection ({
      url: `/v1/app/GoodOrder/${opts.order_sn}`,
      data: opts,
    });
  },
  // 获取直播记录列表
  getPlayRecordList: opts => {
    return apiCollection ({url: '/v1/app/LiveOrder', params: {...opts}});
  },
  // 获取直播记录详情
  getRecordDetail: opts => {
    return apiCollection ({
      url: `/v1/app/LiveOrder/${opts.order_sn}`,
      data: opts,
    });
  },
  // 课程周表
  getCourseWeek: opts => {
    return apiCollection ({url: '/v1/app/CourseWeek', params: {...opts}});
  },
  // 课程月表
  getCourseMonth: opts => {
    return apiCollection ({url: '/v1/app/CourseMonth', params: {...opts}});
  },
  // 创建直播订单
  createPlayOrder: opts => {
    return apiResource ({
      url: `/v1/app/LiveOrder`,
      data: opts,
    });
  },
  // 更新直播订单
  updatePlayOrder: opts => {
    return apiPut ({
      url: `/v1/app/LiveOrder/${opts.order_sn}`,
      data: opts,
    });
  },
  //   检测是否支付成功
  checkPay: opts => {
    return apiPut ({
      url: `/v1/app/Pay/${opts.order_sn}`,
      data: opts,
    });
  },
  // 商品分类
  getGoodCate: opts => {
    return apiCollection ({url: '/v1/app/GoodCate', params: {...opts}});
  },
  // 获取学校风采评论列表
  getArticleEvaluate: opts => {
    return apiCollection ({url: '/v1/app/ArticleEvaluate', params: {...opts}});
  },
  // 发布评论
  createArticleEvaluate: opts => {
    return apiResource ({
      url: `/v1/app/ArticleEvaluate`,
      data: opts,
    });
  },
  // 上传头像
  uploadMyAvatar: opts => {
    return apiResource ({
      url: `/v1/app/User`,
      data: opts,
    });
  },
  // 课程订单取消
  cancelCourseOrder: opts => {
    return apiResource ({
      url: `/v1/app/CourseOrderCancel`,
      data: opts,
    });
  },
  // 获取会员信息
  getMyAvatar: opts => {
    return apiCollection ({url: '/v1/app/User', params: {...opts}});
  },
  // 课程预约
  courseSubscribe: opts => {
    return apiResource ({
      url: `/v1/app/CourseSubscribe`,
      data: opts,
    });
  },
  // 课程热搜关键词
  getCourseCat: opts => {
    return apiCollection ({url: '/v1/app/CourseCat', params: {...opts}});
  },
  // 课程视频播放完成
  courseOver: opts => {
    return apiResource ({
      url: `/v1/app/CourseOver`,
      data: opts,
    });
  },
  // 记录课程观看时间
  recordCourseTime: opts => {
    return apiResource ({
      url: `/v1/app/CourseTime`,
      data: opts,
    });
  },
};



// WEBPACK FOOTER //
// ./src/api/api.js